import styled from 'styled-components';
import { Icon as UnstyledIcon } from 'features/common/components/Icon';
import { Text as UnstyledText } from 'features/common/components/Text';
import { Button as UnstyledButton } from 'features/common/components/Button';
import { Option } from '../ModalReplace/ModalReplace.styles';

export const Icon = styled(UnstyledIcon)`
	width: 72px;
	height: 72px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 48px;
		height: 48px;
	}
`;

export const Text = styled(UnstyledText)`
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 153%;
	padding-top: 38px;
	text-align: center;
	text-transform: none;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding-top: 18px;
	}
`;

export const ContainerBody = styled.div`
	height: 421px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		height: 240px;
	}
`;

export const ContainerActionButtons = styled.div`
	display: flex;
	gap: 16px;
	justify-content: center;
	padding: 0px;
`;

export const ModalButton = styled(UnstyledButton)`
	padding: 0px;
	width: 125px;
	height: 44px;
	font-size: 14px;
	font-weight: 500;
	line-height: 14px;
	font-family: ${({ theme }) => theme.fonts.primary};
`;

export const DeleteOption = styled(Option)`
	opacity: 0.8;
	background-color: ${({ theme }) => theme.colors.red};
`;
